<script setup lang="ts">
import Button, { type ButtonVariant } from '@/components/buttons/Button.vue';
import { I18nKey } from '@/utils/typings';
import { mdiPlus } from '@mdi/js';

withDefaults(
  defineProps<{
    label: I18nKey;
    variant?: ButtonVariant;
  }>(),
  { variant: 'text' },
);
</script>

<template>
  <Button
    :variant="variant"
    size="x-small"
    :icon="mdiPlus"
    iconPosition="start"
    :label="$t(label)"
  />
</template>
